import { MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const WrapperForm = styled("div")(() => ({
  marginTop: 24,
}));

export const ReportOption = styled("li")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
}));

export const ReportOptionText = styled("span")(() => ({
  fontFamily: "Manrope",
  color: colors.gray600,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.25,
}));

export const ReportListTitle = styled("span")(() => ({
  color: colors.brandBlue500,
  fontWeight: 600,
  fontSize: 14,
  lineHeight: "20px",
  letterSpacing: 0.1,
  fontFamily: "Manrope",
}));

export const ReportListWrapper = styled("div")(() => ({
  position: "relative",
  marginTop: 8,
  padding: 12,
  paddingBottom: 38,
  border: `1px solid ${colors.gray300}`,
  borderRadius: 8,
  maxHeight: 300,
  height: 300,
  overflowY: "scroll",
  "& div": {
    paddingBottom: 5,
    paddingTop: 5,
    width: "100%",
  },
}));

export const ReportListName = styled("span")(({ disabled }: { disabled?: boolean }) => ({
  fontFamily: "Manrope",
  fontWeight: 400,
  fontSize: 14,
  lineHeight: "20px",
  letterSpacing: 0.25,
  color: disabled ? "#98A2B3" : colors.gray600,

  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
}));

export const ReportListWithCheckbox = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: 12,
}));

export const ReportAsChecklistWrapper = styled("div")({
  display: "grid",
  gridTemplateColumns: "5fr 1fr",
  gap: 12,
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
});

export const ReportAsChecklist = styled("span")({
  backgroundColor: colors.purple50,
  borderRadius: 100,
  padding: "4px 12px",

  color: colors.purple600,
  fontFamily: "Manrope",
  fontSize: 12,
  fontWeight: 600,
  lineHeight: "16px",
});

export const FormDescriptionWrapper = styled("div")(() => ({
  marginTop: 4,
}));

export const FormDescription = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 400,
  fontSize: 12,
  lineHeight: "16px",
  letterSpacing: 0.4,
  color: colors.gray500,
}));

export const WrapperInput = styled("div")(() => ({
  marginTop: 24,
}));

export const ReportListFooter = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: 8,
  backgroundColor: colors.gray100,
  border: `1px solid ${colors.gray300}`,
  borderBottomLeftRadius: 8,
  borderBottomRightRadius: 8,

  position: "absolute",
  bottom: 0,
  width: "100%",
}));

export const ReportListFooterLink = styled("span")(({ isEnabled }: { isEnabled?: boolean }) => ({
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: 12,
  lineHeight: "16px",
  letterSpacing: 0.5,
  color: isEnabled ? colors.brandBlue500 : colors.gray400,
  cursor: isEnabled ? "pointer" : "not-allowed",
}));

export const ListWrapper = styled("div")(() => ({
  position: "relative",
}));

export const TrimReportOption = styled(MenuItem)({
  overflow: "hidden !important",
  whiteSpace: "nowrap !important",
  textOverflow: "ellipsis !important",
  width: "450px !important",
});
